// Module
var code = "<span class=nlgMonitorLogSearchResult>{{ctrl.leftPart()}}<b>{{ctrl.foundPart()}}</b>{{ctrl.rightPart()}}</span>";
// Exports
module.exports = code;